import { connect } from 'react-redux'
import Finalization from './Finalization'

const mapStateToProps = state => ({
  wizards: state.wizards,
  stock: state.stock,
  tradeIn: state.tradeIn
})

export default connect(mapStateToProps)(Finalization)
